import { render } from "./ReplyDraftBlock.vue?vue&type=template&id=2aa16f16&scoped=true"
import script from "./ReplyDraftBlock.vue?vue&type=script&lang=js"
export * from "./ReplyDraftBlock.vue?vue&type=script&lang=js"

import "./ReplyDraftBlock.vue?vue&type=style&index=0&id=2aa16f16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa16f16"]])

export default __exports__